module.exports = __webpack_public_path__ + "img/heater.81786c13.webp";